<template>
  <div>
    <v-select
      :items="costCentres"
      :label="label"
      :rules="[isRequiredValidator]"
      v-if="$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== settingTypes.NOT_AVAILABLE"
      v-model="contextModel"
      item-text="name"
      item-value="name"
    />
  </div>
</template>

<script>
import { settingTypes } from "../../staticData/SettingsTypes";

export default {
  name: "CostCentreSelect",
  props: {
    value: {
      default: null
    }
  },
  data: () => ({
    settingTypes
  }),
  watch: {
    passengers: {
      deep: true,
      handler: function(passengers) {
        for (let passenger of passengers) {
          if (/*this.contextModel === null &&*/ typeof passenger.defaultCostCentre !== "undefined" && passenger.defaultCostCentre !== null) {
            this.contextModel = passenger.defaultCostCentre.name;
            return;
          }
        }
      }
    }
  },
  computed: {
    passengers() {
      if (
        this.$store.state.TravelService.editedTravelServiceItem !== null &&
        this.$store.state.TravelService.editedTravelServiceItem.travelServiceOrderItemPassengers.length > 0
      ) {
        return this.$store.state.TravelService.editedTravelServiceItem.travelServiceOrderItemPassengers;
      }
      return [];
    },
    isRequiredValidator() {
      return (
        this.$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== this.settingTypes.REQUIRED ||
        (this.value != null && this.value.length > 0) ||
        this.$t("global.error.required")
      );
    },
    label() {
      return (
        this.$t("travelService.costCentre") +
        (this.$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations === this.settingTypes.REQUIRED ? "*" : "")
      );
    },
    costCentres() {
      //let result = [];

      return this.$store.state.TravelService.availableCostCentres;

      //TODO DO PRZEROBKI NA VUEXA

      // if (this.user != null) {
      //   if (typeof this.user.costCentres !== "undefined") {
      //     for (let costCentre of this.user.costCentres) {
      //       result.push(costCentre.name);
      //     }
      //   }
      // }
      //return result;
    },
    contextModel: {
      get() {
        this.setDefaultCostCentre(); // żeby się zaktualizowało i wyliczyło,
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      }
    }
  },
  methods: {
    setDefaultCostCentre() {
      if (this.$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== this.settingTypes.NOT_AVAILABLE) {
        //TODO DO PRZEROBKI NA VUEXA

        // if (this.user != null && this.user.defaultCostCentre != null) {
        //   this.$emit("update:value", this.user.defaultCostCentre.name);
        // }

        return this.user == null ? null : this.user.id;
      }
    }
  }
};
</script>

<style scoped></style>
